"use strict";
/**
 * Infrastructure Domain — DynamoDB Database Record Types
 *
 * Records for image caching, image processing status, image upload metadata,
 * and notification retry queue.
 */
Object.defineProperty(exports, "__esModule", { value: true });
